import { transformSearch } from "@/api/helper.ts";
import { queryClient } from "@/query-client.ts";
import { queryOptions, useMutation } from "@tanstack/react-query";
import { z } from "zod";
import courtLevelService from "../services/court-level-service";

export const courtLevelSearchSchema = z.object({
	search: z.string().optional(),
	include: z.string().optional(),
	page: z.number().nullable().optional(),
	per_page: z.number().optional(),
});

export const courtLevelsQueryOptions = (
	search?: z.infer<typeof courtLevelSearchSchema>,
	options?: { enabled: boolean },
) => {
	return queryOptions({
		queryKey: ["court_level", search],
		queryFn: () => courtLevelService.list(transformSearch(search, ["search"])),
		...options,
	});
};

export const courtLevelQueryOptions = (courtLevelId: string) => {
	return queryOptions({
		queryKey: ["court_level", courtLevelId],
		queryFn: () => courtLevelService.findById(courtLevelId),
	});
};

export const useCourtLevelCreateMutation = (courtLevelId?: string) => {
	return useMutation({
		mutationKey: ["court_level", courtLevelId],
		mutationFn: courtLevelService.create,
		meta: {
			successMessage: "Court level created successfully",
		},
		onSuccess: () =>
			queryClient.invalidateQueries({ queryKey: ["court_level"] }),
	});
};

export const useCourtLevelMutation = (courtLevelId?: string) => {
	return useMutation({
		mutationKey: ["court_level", courtLevelId],
		mutationFn: courtLevelService.upsert,
		meta: {
			successMessage: "Court level updated successfully",
		},
		onSuccess: () =>
			queryClient.invalidateQueries({ queryKey: ["court_level"] }),
	});
};
